export default __webpack_public_path__ + "static/media/comercio_17.84fef5ff.png";